<template>
  <section>
    <qx-search-box
      class="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="查询"
      permpisionsQuery
    >
      <section slot="sourceAddressInfo" slot-scope="prop">
        <ChooseAddress
          :showCloseBtn="true"
          :showCleanBtn="true"
          :selectType="2"
          placeholder="请选择出发城市"
          v-model="prop.form.sourceAddressInfo"
        />
      </section>
      <section slot="desAddressInfo" slot-scope="prop">
        <ChooseAddress
          :showCloseBtn="true"
          :showCleanBtn="true"
          :selectType="2"
          placeholder="请选择目的城市"
          v-model="prop.form.desAddressInfo"
        />
      </section>
    </qx-search-box>
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import ChooseAddress from 'components/chooseAddress/chooseAddress';
import TableBox from './tableBox';
export default {
  components: {
    TableBox,
    ChooseAddress,
  },
  data () {
    return {
      searchBoxData: {
        form: [
          {
            label: '客户名称',
            value: 'customerName',
            type: 'input',
            placeholder: '请输入客户名称',
          },
          {
            label: '收货方',
            value: 'consignee',
            type: 'input',
            placeholder: '请输入收货方',
          },
          {
            label: '出发城市',
            value: 'sourceAddressInfo',
            slot: true,
            default: [],
          },
          {
            label: '目的城市',
            value: 'desAddressInfo',
            type: 'cascader',
            slot: true,
            default: [],
          },
          {
            label: '状态',
            value: 'status',
            type: 'select',
            default: '-1',
            // class: 'especial-radio-group',
            options: [
              { label: '全部', value: '-1' },
              { label: '待调度', value: '1' },
              { label: '已调度', value: '2' },
            ],
            onChangeRadio: () => {
              this.$refs.searchBox.sub();
            },
          },
        ],
      },
    };
  },
  methods: {

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      if (searchBoxData.sourceAddressInfo && searchBoxData.sourceAddressInfo.length) {
        if (searchBoxData.sourceAddressInfo[0]) {
          searchBoxData.sourceProvince = `${searchBoxData.sourceAddressInfo[0]}`;
        }
        if (searchBoxData.sourceAddressInfo[1]) {
          searchBoxData.sourceCity = `${searchBoxData.sourceAddressInfo[1]}`;
        }
        delete searchBoxData.sourceAddressInfo;
      }
      if (searchBoxData.desAddressInfo && searchBoxData.desAddressInfo.length) {
        if (searchBoxData.desAddressInfo[0]) {
          searchBoxData.desProvince = `${searchBoxData.desAddressInfo[0]}`;
        }
        if (searchBoxData.desAddressInfo[1]) {
          searchBoxData.desCity = `${searchBoxData.desAddressInfo[1]}`;
        }
        delete searchBoxData.desAddressInfo;
      }
      this.$refs.tableBox.saveSearchBoxData({
        ...searchBoxData,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
